'use client';

import { useState } from 'react';
import { LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { useAppContext } from '@/contexts/AppContext';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';

export default function LogoutButton() {
  const { logout } = useAuth();
  const { isBotRunning, toggleBotRunning } = useAppContext();
  const [showDialog, setShowDialog] = useState(false);

  const handleLogoutClick = () => {
    // Always show dialog, regardless of bot status
    setShowDialog(true);
  };

  const handleStopBotAndLogout = () => {
    if (isBotRunning) {
      toggleBotRunning(); // Stop the bot if it's running
    }
    setShowDialog(false); // Close the dialog
    logout(); // Log out
  };

  return (
    <>
      <Button className="w-full" onClick={handleLogoutClick}>
        <LogOut className="h-5 w-5 mr-2" />
        Logout
      </Button>

      {/* Warning Dialog */}
      <Dialog open={showDialog} onOpenChange={setShowDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {isBotRunning ? "Bot is Currently Running" : "Confirm Logout"}
            </DialogTitle>
            <DialogDescription className="pt-2">
              {isBotRunning 
                ? "The batch finder bot is currently running. Logging out will stop the bot and you may miss batches."
                : "Are you sure you want to logout?"}
            </DialogDescription>
          </DialogHeader>
          
          <div className="my-2 text-center text-muted-foreground">
            Hope you were able to earn some great batches today!
          </div>
          
          <DialogFooter className="flex flex-col sm:flex-row gap-2 sm:gap-0 mt-4">
            <Button variant="outline" onClick={() => setShowDialog(false)}>
              Cancel
            </Button>
            <Button 
              variant={isBotRunning ? "destructive" : "default"} 
              onClick={handleStopBotAndLogout}
            >
              {isBotRunning ? "Stop Bot & Logout" : "Logout"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
